export default "__VITE_ASSET__bd1ced37__"